/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  function check_mobile_nav() {
    if($(window).width() > 768) {
      $('.nav-mobile').hide();
      $('.nav-mobile-toggle').removeClass('nav-mobile-toggle-opened');
    }
  }

  function homepage_box_resize() {
    if($('body').hasClass('home')){
      if($(window).width() > 768) {
        $('.homepage-box-text-container').height('auto');
        $('.homepage-box-read-more').css('position', 'relative');
        $('.homepage-box-read-more').css('bottom', 'auto');

        max_homepage_box_text_height = 0;
        $('.homepage-box-text-container').each(function(){
          if($(this).height() > max_homepage_box_text_height){
            max_homepage_box_text_height = $(this).height();
          }
        });
        $('.homepage-box-text-container').height(max_homepage_box_text_height + 30);
        $('.homepage-box-read-more').css('position', 'absolute');
        $('.homepage-box-read-more').css('bottom', '15px');

      } else {
        $('.homepage-box-text-container').height('auto');
        $('.homepage-box-read-more').css('position', 'relative');
        $('.homepage-box-read-more').css('bottom', 'auto');
      }
    }
  }

  function footer_navigation_page_resize() {
    if($(window).width() < 768){
      $(".footer-navigation-page-content").appendTo(".footer-navigation-page-menu .nav > li.current-menu-item");
    } else {
      if($(".footer-navigation-page-menu .footer-navigation-page-content").length > 0) {
        $(".footer-navigation-page-menu").after($(".footer-navigation-page-content").clone());
        $(".footer-navigation-page-menu .footer-navigation-page-content").remove();
      }
    }
  }

  function nav_tabs_resize_fallback(){
    if($(window).width() > 767){

      if($('.primary-navigation-page .nav-tabs.nav-tabs-cloned').length > 0) {
        $('.primary-navigation-page-header-text').after($('.primary-navigation-page .nav-tabs.nav-tabs-cloned').clone(true, true).removeClass('nav-tabs-cloned'));
        $('.primary-navigation-page .nav-tabs.nav-tabs-cloned').remove();
        $('.primary-navigation-page-header-nav-tabs .nav-tabs').css('visibility', 'visible');
      }

      nav_tabs_li_width = 0;
      $('.primary-navigation-page-header-nav-tabs .nav-tabs li:not(:first-child)').each(function(){
        nav_tabs_li_width = nav_tabs_li_width + $(this).width();
      });

      if(nav_tabs_li_width > ($('.primary-navigation-page-header-nav-tabs .nav-tabs').width() - 30)) {
        $(".tab-content").before($('.primary-navigation-page-header-nav-tabs .nav-tabs').clone(true, true).addClass('nav-tabs-cloned'));
        $('.primary-navigation-page-header-nav-tabs .nav-tabs').remove();
      } else {
        $('.primary-navigation-page-header-text').after($('.primary-navigation-page .nav-tabs.nav-tabs-cloned').clone(true, true).removeClass('nav-tabs-cloned'));
        $('.primary-navigation-page .nav-tabs.nav-tabs-cloned').remove();
        $('.primary-navigation-page-header-nav-tabs .nav-tabs').css('visibility', 'visible');
      }

      if($('.primary-navigation-page .nav-tabs.nav-tabs-cloned').length > 0) {
        $('.panel').each(function(p){
          if($($('.tab-pane')[p]).text().trim() === '') {
            $($('.tab-pane')[p]).html($(this).find('.panel-body').html());
          }
        });
      }
    }
  }

  $(document).ready(function(event) {
    check_mobile_nav();

    // Toggle mobile nav
    $('.nav-mobile-toggle').on('click', function(){
      if($('.nav-mobile').is(':visible')) {
        $('.nav-mobile').hide();
        $(this).removeClass('nav-mobile-toggle-opened');
      } else {
        $('.nav-mobile').show();
        $(this).addClass('nav-mobile-toggle-opened');
      }
    });

    homepage_box_resize();

    // Primary navigation page
    $('#primary-navigation-page-header-first').on('click', function(e){
      e.preventDefault();
      if($('.primary-navigation-page .nav-tabs.nav-tabs-cloned').length > 0) {
        $('.primary-navigation-page .nav-tabs.nav-tabs-cloned li:first-child a').tab('show');
        $('.primary-navigation-page .panel-group .panel:first-child .panel-heading a').click();
        $('.page-header-image-container img').attr('src', $(this).attr('replace-page-header-image'));
      } else {
        $('.primary-navigation-page-header .nav-tabs li:first-child a').tab('show');
        $('.primary-navigation-page .panel-group .panel:first-child .panel-heading a').click();
        $('.page-header-image-container img').attr('src', $(this).attr('replace-page-header-image'));
      }
    });

    $('.primary-navigation-page-header .nav-tabs a').on('click', function(e) {
      e.preventDefault();
      $(this).tab('show');
      if($(this).attr('replace-page-header-image')){
        $('.page-header-image-container img').attr('src', $(this).attr('replace-page-header-image'));
      } else {
        $('.page-header-image-container img').attr('src', $('#primary-navigation-page-header-first').attr('replace-page-header-image'));
      }
    });

    $('.primary-navigation-page-header .nav-tabs').tabCollapse();

    $('.primary-navigation-page .nav-tabs.nav-tabs-cloned a').on('click', function(e) {
      e.preventDefault();
      $(this).tab('show');
      if($(this).attr('replace-page-header-image')){
        $('.page-header-image-container img').attr('src', $(this).attr('replace-page-header-image'));
      } else {
        $('.page-header-image-container img').attr('src', $('#primary-navigation-page-header-first').attr('replace-page-header-image'));
      }
    });

    $('.primary-navigation-page .nav-tabs.nav-tabs-cloned').tabCollapse();

    $('.primary-navigation-page-header .nav-tabs').on('shown-accordion.bs.tabcollapse', function(){
      $('.primary-navigation-page .panel-group .panel:first-child .panel-heading a').click();
    });

    // Top navigation page
    $('.top-navigation-page-tabs .nav-tabs a').on('click', function(e) {
      e.preventDefault();
      $(this).tab('show');
      if($(this).attr('replace-page-header-image')){
        $('.page-header-image-container img').attr('src', $(this).attr('replace-page-header-image'));
      }
    });

    $('.top-navigation-page-tabs .nav-tabs').tabCollapse();

    // Footer navigation page
    footer_navigation_page_resize();

    // Stellenbörse
    var options = {
      valueNames: [ 'stellenborse-list-ort' ]
    };
    stellenborse_list = new List('stellenborse-list', options);

    stellenborse_list_cities = [];
    $('.stellenborse-list-ort').each(function(){
      if($.inArray($(this).text(), stellenborse_list_cities) < 0) {
        stellenborse_list_cities.push($(this).text());
      }
    });

    $(stellenborse_list_cities.sort()).each(function(key, value){
      $('.stellenborse-list-select select').append('<option value"'+value+'">'+value+'</option>');
    });

    $('.stellenborse-list-select select').on('change', function(e){
      e.preventDefault();
      stellenborse_list.search($(this).val());
    });

    nav_tabs_resize_fallback();
    
    // Newsletter popup
        
    $('#newsletter-pre-continue-btn').on('click', function(e){
      e.preventDefault();
      
      // copy entered email into the extended form
      var newsletterEmailField = $('.newsletter-popup-form input[type="email"]');

      newsletterEmailField.val($("#newsletter-pre-email").val());
      newsletterEmailField.trigger("change");
      
      $('#newsletter-popup').addClass('visible');
      $('body').css('overflow', 'hidden').on('touchmove', function(e) {
         e.preventDefault();
      });
    });
    
    // let the user register using email only
    
    $('#newsletter-only-email-btn').on('click', function(e){
      e.preventDefault();
      
      $('.newsletter-popup-form button[type="submit"]').click();
    });
    
    // hide irrelevant text on newsletter form submit
    
    $('.newsletter-popup-form').on('submit', function(e){
      $(".newsletter-popup-header p").hide();
      $("#newsletter-only-email-btn").hide();
    });
    
    function closePopup() {
      $('.popup').removeClass('visible');
      $('body').css('overflow', 'auto').off('touchmove');
    }
    
    $('.popup').on('click', function(e){
      if( $(e.target).is('.popup, .popup-close') ) {
        e.preventDefault();
        closePopup();
      }
    });
    
    $(document).keyup(function(e){
      // close on esc
      if(e.which=='27'){ 
        closePopup();
      }
    });
    
  });

  $(window).load(function(event) {
    homepage_box_resize();

    nav_tabs_resize_fallback();
  });

  $(window).resize(function(event) {
    check_mobile_nav();

    homepage_box_resize();

    footer_navigation_page_resize();

    nav_tabs_resize_fallback();
  });

})(jQuery); // Fully reference jQuery after this point.
